import { Dto, DtoWithId } from "@mango/core";
import { User } from "../user/user";

@Dto({fullName: "AccessMonitor.Logic.Alert"})
export class Alert extends DtoWithId {
	title: string;
	message: string;
	date: Date;
	type: number;
	expiringDate: Date;
	receivedBy: User;
}